import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder

const BASE = serviceName + '/learning/material'

export function getMaterialPage(data) {
  return request({
    url: BASE + '/page',
    method: 'post',
    data,
  })
}

export function addMaterial(data) {
  return request({
    url: BASE + '/add',
    method: 'post',
    data,
  })
}

export function updateMaterial(data) {
  return request({
    url: BASE + '/update',
    method: 'post',
    data,
  })
}

export function deleteMaterial(id) {
  return request({
    url: BASE + '/delete/' + id,
    method: 'post',
  })
}

export function setMaterialStatus(id, status) {
  return request({
    url: BASE + '/status/' + id,
    method: 'post',
    params: { status },
  })
}